import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import gsap from 'gsap'
import * as dat from 'lil-gui'



/**
 * Base
 */

//Debug
// const gui = new dat.GUI()
// gui.domElement.id = 'gui'

//Canvas
const canvas = document.querySelector('.webgl')

// Scene
const scene = new THREE.Scene()




/**
 * Models
 */

// Load the correct model file based on the URL
const pathPrefix = window.location.pathname.includes('/en/') ? '../' : './'
const gltfPath = pathPrefix + 'models/globe.glb'
const dracoPath = pathPrefix + '/draco/'

const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath(dracoPath)

const gltfLoader = new GLTFLoader()
gltfLoader.setDRACOLoader(dracoLoader)

gltfLoader.load(
    gltfPath,
    (gltf) => {
        scene.add(gltf.scene)
    }
)




/**
 * Debug
 */

// Cursor
const cursor = {
    x: 0,
    y: 0
}

window.addEventListener('mousemove', (event) => {
    cursor.x = event.clientX / sizes.width - 0.5
    cursor.y = - (event.clientY / sizes.height - 0.5)

    // console.log(cursor.x, cursor.y)
})

/**
 * Textures
 */

const loadingMabager = new THREE.LoadingManager()

loadingMabager.onStart = () => {
    console.log('onStart')
}

loadingMabager.onLoad = () => {
    console.log('onLoaded')
}

loadingMabager.onProgress = () => {
    console.log('onProgress')
}

loadingMabager.onError = () => {
    console.log('onError')
}
const textureLoader = new THREE.TextureLoader(loadingMabager)
// const texture = textureLoader.load('/textures/door.jpg')



/**
 * Lights
 */

const ambientLight = new THREE.AmbientLight(0xffffff, 1)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0xffffff, 3)
directionalLight.position.set(4.8, 4.5, -2.9)
scene.add(directionalLight)




/**
 * Objects
 */



//Objects
// const geometry = new THREE.BoxGeometry(1, 1, 1)
// const material = new THREE.MeshStandardMaterial({ color: 0x000000 })
// const mesh = new THREE.Mesh(geometry, material)
// scene.add(mesh)





//Debug
// gui
//     .add(mesh.position, 'y')
//     .min(- 3)
//     .max(3)
//     .step(0.01)
//     .name('y-position')

// gui
//     .add(mesh, 'visible')

// gui
//     .add(material, 'wireframe')

// gui
//     .addColor(material, 'color')

// gui.add(ambientLight, 'intensity').min(0).max(1).step(0.001)

// Sizes
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
};

//Resize

window.addEventListener('resize', () => {
    //Update size
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    //Update camera
    camera.aspect = sizes.width / sizes.height
    if(camera.aspect > 1 ){
        camera.position.z = 3
    } else {
        camera.position.z = 5
    }

    camera.updateProjectionMatrix()

    //Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

})

// Camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 1, 1000)
if(camera.aspect > 1 ){
    camera.position.z = 3
} else {
    camera.position.z = 5
}
// camera.lookAt(mesh.position)
scene.add(camera)

//Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.minDistance = 2.2


// Renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true,
    antialias: true
})

renderer.outputEncoding = THREE.sRGBEncoding
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))


//Clock
const clock = new THREE.Clock()

//gsap
// gsap.to(mesh.position,{ duration: 1, delay: 1, x:2 })


/**
 * Animate
 */
const tick = () => {
    //Clock
    const elapsedTime = clock.getElapsedTime()

    //measure zoom
    // const d = controls.getDistance()
    // console.log(d)

    


    // Update objects
    // mesh.rotation.y = elapsedTime


    //Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()